module.exports = __webpack_public_path__ + "media/images/stat-current-streak-dark-734da232.svg";